"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDynamicCodeRequest = void 0;
var GetDynamicCodeRequest = /** @class */ (function () {
    function GetDynamicCodeRequest() {
    }
    return GetDynamicCodeRequest;
}());
exports.GetDynamicCodeRequest = GetDynamicCodeRequest;
//# sourceMappingURL=getDynamicCode.request.js.map